import { Link } from "react-router-dom";
import Resume from "../assets/resume.pdf";
import * as ROUTES from "../config/Routes";

const Header = () => {
  return (
    <nav class="navbar navbar-expand-lg navbar-light">
      <Link
        className="header__icon"
        to={ROUTES.HOME}
        style={{ textDecoration: "none" }}
      >
        <h1> Ria Ratna Sari</h1>
      </Link>
      <button
        class="navbar-toggler"
        type="button"
        data-toggle="collapse"
        data-target="#navbarSupportedContent"
        aria-controls="navbarSupportedContent"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span class="navbar-toggler-icon"></span>
      </button>

      <div class="collapse navbar-collapse" id="navbarSupportedContent">
        <ul className="navbar-nav ml-auto">
          <li class="nav-item">
            <a href="#technical-skills" className="nav-menu">
              Technical Skills
            </a>
          </li>
          <li class="nav-item">
            <a href="#portfolio" className="nav-menu">
              Portfolio
            </a>
          </li>

          <li class="nav-item">
            <a
              className="nav-menu"
              href={Resume}
              target="_blank"
              rel="noopener noreferrer"
            >
              Resume
            </a>
          </li>

          <li class="nav-item">
            <a
              className="nav-menu"
              href="https://riaratnaasari.wordpress.com/"
              target="_blank"
              rel="noopener noreferrer"
            >
              Personal Blog
            </a>
          </li>
        </ul>
      </div>
    </nav>
  );
};

export default Header;
